// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { showSnackBar } from "../../snackbar/actions"
import { timesheetFieldClient } from "../../../app/rpc/client"
import {
  BatchGetTimesheetFieldOptionsRequest,
  BatchGetTimesheetFieldOptionsResponse
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type BatchGetTimesheetFieldOptionsRpc = (request: BatchGetTimesheetFieldOptionsRequest) => Observable<BatchGetTimesheetFieldOptionsResponse>

export const batchGetTimesheetFieldOptions = (batchGetTimesheetFieldOptionsRpc: BatchGetTimesheetFieldOptionsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.batchGetTimesheetFieldOptions.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(batchGetTimesheetFieldOptionsRpc),
          map(t => t.toObject().timesheetFieldOptionsList),
          map(Slice.setTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_batch_get_timesheet_field_options_failed",
              message: "Failed to load timesheet field values. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const batchGetTimesheetFieldOptionsRpc = (request: BatchGetTimesheetFieldOptionsRequest): Observable<BatchGetTimesheetFieldOptionsResponse> =>
  grpc(() => timesheetFieldClient.batchGetTimesheetFieldOptions(request, null))

export default batchGetTimesheetFieldOptions(batchGetTimesheetFieldOptionsRpc)
